import { translate } from "../translations/index.ts";
import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router";
import pencilIllustration from "../images/pencil.png";
import lightbulbsIllustration from "../images/lightbulbs.png";

export default function Join() {
  const [searchParams] = useSearchParams();
  const [touched, setTouched] = useState(false);
  const error = searchParams.get("error");
  const navigate = useNavigate();

  function goToVotingSession(event) {
    event.preventDefault();
    const data = new FormData(event.target.closest("form"));
    const code = data.get("session[code]").trim();

    if (code) navigate(`/votingsession/${code}`);
  }

  return (
    <>
      <form
        className="page__container"
        onSubmit={goToVotingSession}
        onChange={() => setTouched(true)}
      >
        <img
          src={lightbulbsIllustration}
          alt=""
          className="page__illustration"
        />
        <h1 className="page__title" id="startTitle">
          <span className="--highlighted">{translate("joinPage.title")}</span>
        </h1>
        <div className="input">
          <input
            className="input__field"
            placeholder={translate("joinPage.joinSession.placeholder")}
            aria-labelledby="startTitle"
            name="session[code]"
          />
          {error === "INVALID_CODE" && !touched && (
            <p className="input__error">
              {translate("joinPage.sessionNotFound")}
            </p>
          )}
        </div>
        <button className="button button--lg">
          {translate("joinPage.submit")}
        </button>
      </form>
      <div className="page__section page__section--accent">
        <img src={pencilIllustration} alt="" className="page__decoration" />
      </div>
    </>
  );
}
